// Figma Bundle Builder (sections/fg-bundle.liquid): a copy of hat-bundle.js, the live bundle page's reviewed cart and
// pricing logic, with two changes only: the main button's labels and the Bestseller badge wording come from the section
// (data-label-empty, data-label-ready, data-best-label). The live page keeps hat-bundle.js.
// Hat bundle builder, a replica of aug11.co/pages/hat-bundle: every Add and stepper click changes the real Shopify
// cart straight away, the panel always shows what the cart says (so totals and discounts are the cart's own numbers),
// and the main button goes straight to checkout. Free shipping and free gift amounts come from the Kaching Cart
// tiered promotions bar when it is on the page; the gift itself is chosen in the Kaching drawer.
(() => {
  const root = document.querySelector('.custom-bundle');
  if (!root) return;

  const MAX_ITEMS = 3;
  const moneyFormat = root.dataset.money || '${{amount}}';
  const base = window.Shopify?.routes?.root || '/';
  let shipCents = Number(root.dataset.ship);
  let giftCents = Number(root.dataset.gift);
  let cart = { items: [] };
  let queue = Promise.resolve();

  const $ = (sel) => root.querySelector(sel);
  const $$ = (sel) => root.querySelectorAll(sel);
  const panel = $('[data-hb-panel]');
  const cards = new Map([...root.querySelectorAll('.custom-bundle__collection-product')].map((c) => [Number(c.dataset.variant), c]));
  // every product in the bundle collection, sold out ones too, so a hat added elsewhere still counts as a hat
  const hatIds = new Set((root.querySelector('[data-hb-hat-ids]')?.dataset.hbHatIds || '').split(',').filter(Boolean).map(Number));
  const isMobile = () => window.innerWidth <= 768;

  // aug11's bar sits above the header; the section renders it in place and moves it up
  const bar = document.querySelector('[data-hb-bar]');
  const headerSection = document.querySelector('.site-header')?.closest('.shopify-section');
  if (bar && headerSection) headerSection.before(bar);
  // aug11's phone header hides while scrolling down and comes back on scroll up (CSS: .hb-header-hidden)
  let lastScrollY = window.scrollY;
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    headerSection?.classList.toggle('hb-header-hidden', y > lastScrollY && y > 200);
    lastScrollY = y;
  }, { passive: true });

  const money = (cents) => {
    const group = (n, sep) => n.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    const [whole, dec] = (cents / 100).toFixed(2).split('.');
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) =>
      key === 'amount_no_decimals' ? group(String(Math.round(cents / 100)), ',')
      : key === 'amount_with_comma_separator' ? `${group(whole, '.')},${dec}`
      : `${group(whole, ',')}.${dec}`);
  };
  const moneyShort = (cents) => (cents % 100 === 0 ? money(cents).replace(/[.,]00(?=\D*$)/, '') : money(cents));

  // Kaching opens its drawer on cart calls to the .js endpoints. aug11 never opens a drawer while you pick, so
  // cart calls use Shopify's .json endpoints (same API) through the page's own fetch. That keeps Shopify's
  // add to cart events, which feed the Meta pixel and analytics.
  const cartFetch = (path, body) => {
    const opts = body
      ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body), credentials: 'same-origin' }
      : { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' };
    // a stalled request on a weak phone connection must not freeze the queue
    if (window.AbortSignal?.timeout) opts.signal = AbortSignal.timeout(10000);
    else if (window.AbortController) { const c = new AbortController(); setTimeout(() => c.abort(), 10000); opts.signal = c.signal; }
    return window.fetch(base + path, opts).then(async (res) => {
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
      return data;
    }, (e) => {
      if (e?.name === 'TimeoutError' || e?.name === 'AbortError') throw new Error('Slow connection. Check your bundle before adding again.');
      throw e;
    });
  };
  const drawerIsOpen = () => document.documentElement.classList.contains('kaching-body__cart-open');
  // a third-party promise must never hold up the page
  const settle = (p, ms) => Promise.race([Promise.resolve(p).catch(() => {}), new Promise((r) => { setTimeout(r, ms); })]);

  // Free shipping and free gift thresholds: the Kaching Cart settings are the store's real rule.
  // If Kaching is on the page but its free gift tier is off, the store is not giving a gift: no gift button.
  let giftOn = true;
  try {
    const props = window.__kachingCartProps;
    const tiers = props?.cartSettings?.tieredPromotionsBar;
    const gift = tiers?.isActive ? tiers.tiers.find((t) => t.type === 'product-discount') : null;
    if (tiers?.isActive) {
      const ship = tiers.tiers.find((t) => t.type === 'shipping-discount');
      if (ship) shipCents = Math.round(ship.threshold * 100);
      if (gift) giftCents = Math.round(gift.threshold * 100);
    }
    if (props && !gift) giftOn = false;
  } catch (e) { /* keep the section settings */ }
  if (!(shipCents > 0)) shipCents = 9000;
  if (!(giftCents > shipCents)) giftOn = false;
  $$('[data-hb-ship-amt]').forEach((el) => { el.textContent = moneyShort(shipCents); });

  const isGift = (line) => typeof line.properties?._kaching_cart === 'string' && line.properties._kaching_cart.includes('product-discount');
  // what counts towards the gift: everything but the gift line, which goes back to full price once the cart drops under it
  const nonGiftTotal = () => cart.items.filter((l) => !isGift(l)).reduce((s, l) => s + l.final_line_price, 0);
  const hatLines = () => cart.items.filter((l) => (hatIds.has(l.product_id) || cards.has(l.variant_id)) && !isGift(l));
  const qtyOf = (variantId) => hatLines().filter((l) => l.variant_id === variantId).reduce((n, l) => n + l.quantity, 0);
  const maxOf = (card) => (card.dataset.max === '' ? Infinity : Number(card.dataset.max));

  function showError(message) {
    $$('[data-hb-error]').forEach((el) => { el.textContent = message; el.hidden = !message; });
  }

  const svgX = '<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none"><path d="M0.5 5.5L5.5 0.5M0.5 0.5L5.5 5.5" stroke="black" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const svgPlus = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 3C8.27614 3 8.5 3.22386 8.5 3.5V8H13C13.2761 8 13.5 8.22386 13.5 8.5C13.5 8.77614 13.2761 9 13 9H8.5V13.5C8.5 13.7761 8.27614 14 8 14C7.72386 14 7.5 13.7761 7.5 13.5V9H3C2.72386 9 2.5 8.77614 2.5 8.5C2.5 8.22386 2.72386 8 3 8H7.5V3.5C7.5 3.22386 7.72386 3 8 3Z" fill="#9CA3AF"/></svg>';

  let lastSlotCount = 0;
  function renderSlots(lines) {
    const track = $('[data-hb-slots]');
    const slider = $('[data-hb-slider]');
    const focusedSlot = track.contains(document.activeElement) ? [...track.querySelectorAll('.selected-product-box__remove')].indexOf(document.activeElement) : -1;
    const flat = [];
    lines.forEach((l) => { for (let i = 0; i < l.quantity; i++) flat.push(l); });
    track.innerHTML = '';
    // aug11's slot count: 3 empty slots, then the picked hats plus one empty slot up to 3, then one slot per hat
    const count = flat.length > MAX_ITEMS ? flat.length : flat.length === 0 ? MAX_ITEMS : Math.min(flat.length + 1, MAX_ITEMS);
    for (let i = 0; i < count; i++) {
      const l = flat[i];
      const box = document.createElement('div');
      box.className = l ? 'selected-product-box filled' : 'selected-product-box empty';
      if (!l) {
        box.innerHTML = `<div class="selected-product-box__empty">${svgPlus}</div>`;
      } else {
        const card = cards.get(l.variant_id);
        const title = card ? card.dataset.title : l.product_title;
        const content = document.createElement('div');
        content.className = 'selected-product-box__content';
        const src = card?.dataset.img || l.image || '';
        const img = document.createElement('img');
        img.className = 'selected-product-box__image';
        img.src = src; img.alt = title;
        const x = document.createElement('button');
        x.type = 'button'; x.className = 'selected-product-box__remove'; x.innerHTML = svgX;
        x.setAttribute('aria-label', `Remove ${title}`);
        x.addEventListener('click', () => { x.disabled = true; removeOne(l.key); });
        const name = document.createElement('span');
        // the card's colour name (Khaki/Green), not the full title, which two hats of one line cut to the same words
        name.className = 'selected-product-box__title'; name.textContent = card?.dataset.name || title;
        // the cart's own per-hat price after discounts, struck through against the full price
        const unit = Math.round(l.final_line_price / l.quantity);
        const price = document.createElement('div');
        price.className = 'selected-product-box__price';
        price.innerHTML = (l.original_price > unit ? `<span class="selected-product-box__price-compare">${money(l.original_price)}</span>` : '')
          + `<span class="selected-product-box__price-current">${money(unit)}</span>`;
        content.append(...(src ? [img] : []), x, name, price);
        box.append(content);
      }
      track.append(box);
    }
    const scrollable = flat.length > MAX_ITEMS;
    slider.classList.toggle('is-scrollable', scrollable);
    slider.style.setProperty('--slider-item-count', String(count));
    // like aug11: when a hat is added to a full slider, show the newest one at the end
    if (scrollable && flat.length > lastSlotCount) track.scrollLeft = track.scrollWidth;
    lastSlotCount = flat.length;
    updateArrows();
    // keep keyboard focus in the slots after a remove
    if (focusedSlot >= 0) {
      const xs = track.querySelectorAll('.selected-product-box__remove');
      (xs[Math.min(focusedSlot, xs.length - 1)] || $('.custom-bundle__wrapper-left-title')).focus();
    }
  }

  function updateArrows() {
    const slider = $('[data-hb-slider]');
    const track = $('[data-hb-slots]');
    const prev = $('[data-hb-prev]');
    const next = $('[data-hb-next]');
    if (!slider.classList.contains('is-scrollable')) { track.scrollLeft = 0; prev.hidden = true; next.hidden = true; return; }
    prev.hidden = false; next.hidden = false;
    prev.disabled = track.scrollLeft <= 1;
    next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
  }

  function render() {
    const lines = hatLines();
    const n = lines.reduce((s, l) => s + l.quantity, 0);
    const total = cart.total_price || 0;
    // the total is the whole cart, what checkout charges before shipping; other items get their own line
    const others = cart.items.filter((l) => !isGift(l) && !lines.includes(l));
    const otherCount = others.reduce((s, l) => s + l.quantity, 0);
    const otherCents = others.reduce((s, l) => s + l.final_line_price, 0);
    const was = lines.concat(others).reduce((s, l) => s + l.original_line_price, 0);
    const giftUnlocked = giftOn && n > 0 && nonGiftTotal() >= giftCents;
    const giftInCart = cart.items.some(isGift);

    $$('[data-hb-fill]').forEach((el) => { el.style.width = `${Math.min(100, (n / MAX_ITEMS) * 100)}%`; });
    $$('.bundle-progress-point').forEach((el) => el.classList.toggle('active', Number(el.dataset.step) <= Math.min(n, MAX_ITEMS)));

    const totalEl = $('[data-hb-total]');
    totalEl.innerHTML = was > total && n > 0
      ? `<span class="bundle-total__result">${money(total)}</span><span class="bundle-total__original">${money(was)}</span>`
      : `<span class="bundle-total__result">${money(total)}</span>`;
    const other = $('[data-hb-other]');
    other.hidden = otherCount === 0;
    other.textContent = `Includes ${money(otherCents)} for ${otherCount} other ${otherCount === 1 ? 'item' : 'items'} in your cart`;

    renderSlots(lines);

    cards.forEach((card, id) => {
      const qty = qtyOf(id);
      const max = maxOf(card);
      const qtyEl = card.querySelector('[data-hb-qty]');
      if (qtyEl.textContent !== String(qty)) qtyEl.textContent = qty;
      const addBtn = card.querySelector('.custom-bundle__collection-product-atc-button');
      const stepper = card.querySelector('[data-hb-stepper]');
      const addHadFocus = document.activeElement === addBtn;
      const stepperHadFocus = stepper.contains(document.activeElement);
      addBtn.classList.remove('is-adding');
      addBtn.classList.toggle('custom-bundle-hidden', qty > 0);
      stepper.classList.toggle('custom-bundle-hidden', qty === 0);
      addBtn.disabled = max < 1;
      stepper.querySelector('[data-hb-plus]').disabled = qty >= max;
      // keep keyboard focus on the card when Add turns into the stepper and back, and off a + that just disabled
      if (addHadFocus && qty > 0) (qty >= max ? stepper.querySelector('[data-hb-minus]') : stepper.querySelector('[data-hb-plus]')).focus();
      else if (stepperHadFocus && qty === 0) addBtn.focus();
      else if (stepperHadFocus && document.activeElement?.disabled) stepper.querySelector('[data-hb-minus]').focus();
    });

    const submit = $('[data-hb-submit]');
    if (!submit.classList.contains('is-checking-out')) {
      submit.disabled = n === 0;
      submit.classList.toggle('enabled', n > 0);
      submit.textContent = n === 0 ? (root.dataset.labelEmpty || 'Start bundling') : (root.dataset.labelReady || 'Checkout');
    }
    $('.custom-bundle__wrapper-atc-buttons').classList.toggle('has-bundle-items', n > 0);
    $$('[data-hb-gift]').forEach((b) => { b.hidden = !giftUnlocked || giftInCart; });
    if (n === 0 && isMobile()) panel.classList.add('collapsed');
    updateMobileVisibility();
    updateModalFooter();
  }

  // Mobile, like aug11: the tracker sits at the top of the page; once it scrolls away the panel slides up as a
  // bottom bar (tracker only while empty, tracker + View Bundle + Checkout once hats are in); View Bundle opens it.
  const mobileProgress = $('[data-hb-mobile-progress]');
  function updateMobileVisibility() {
    if (!isMobile()) { panel.classList.remove('is-mobile-visible', 'custom-bundle__wrapper-left--mobile-bar-only', 'collapsed'); return; }
    const headerBottom = document.querySelector('.site-header')?.getBoundingClientRect().bottom || 0;
    const past = !mobileProgress || mobileProgress.getBoundingClientRect().bottom <= Math.max(headerBottom, 0);
    const hasItems = hatLines().length > 0;
    panel.classList.toggle('is-mobile-visible', past);
    panel.classList.toggle('custom-bundle__wrapper-left--mobile-bar-only', past && !hasItems);
  }
  if (isMobile()) panel.classList.add('collapsed');
  window.addEventListener('scroll', updateMobileVisibility, { passive: true });
  document.querySelector('.site-header')?.addEventListener('transitionend', updateMobileVisibility);
  let wasMobile = isMobile();
  window.addEventListener('resize', () => {
    if (isMobile() && !wasMobile) panel.classList.add('collapsed');
    wasMobile = isMobile();
    updateMobileVisibility();
    updateArrows();
  });

  // One cart call at a time, each reading the latest cart, so fast taps never race.
  let pending = 0;
  let shopperOpenedDrawer = false;
  let ourCall = false;
  function run(task) {
    pending += 1;
    root.classList.add('is-busy');
    queue = queue.then(async () => {
      showError('');
      ourCall = true;
      try {
        await task();
      } catch (e) {
        showError(e.message);
      }
      try { cart = await cartFetch('cart.json'); } catch (e) { /* keep the last cart */ }
      try {
        render();
        // the theme's header bag dot, and aug11's count badge on the header bag (this page only)
        document.querySelectorAll('[data-cart-drawer-toggle]').forEach((el) => {
          el.classList.toggle('cart__toggle--has-items', cart.item_count > 0);
          let badge = el.querySelector('.hb-bag-num');
          if (!badge) { badge = document.createElement('span'); badge.className = 'hb-bag-num'; badge.setAttribute('aria-hidden', 'true'); el.append(badge); }
          badge.textContent = String(cart.item_count || 0);
        });
        // if a Kaching update ever starts opening its drawer on these calls too, close it again (never one the shopper opened)
        guardDrawer();
        window.kachingCartApi?.refreshCart?.();
      } catch (e) { /* one bad render must not stop the next tap */ }
    }).catch(() => {}).finally(() => {
      pending -= 1;
      if (pending === 0) root.classList.remove('is-busy');
    });
    return queue;
  }

  const checkingOut = () => $('[data-hb-submit]').classList.contains('is-checking-out');
  function change(variantId, delta, btn) {
    if (checkingOut()) return queue;
    if (btn && delta > 0) btn.classList.add('is-adding');
    return run(async () => {
      if (delta > 0) return cartFetch('cart/add.json', { items: [{ id: variantId, quantity: delta }] });
      const line = hatLines().filter((l) => l.variant_id === variantId).pop();
      if (line) return cartFetch('cart/change.json', { id: line.key, quantity: Math.max(0, line.quantity + delta) });
      return null;
    });
  }

  // one fewer of a cart line, read from the cart when the call runs so queued taps never undo each other
  function removeOne(key) {
    if (checkingOut()) return queue;
    return run(async () => {
      const line = cart.items.find((l) => l.key === key);
      if (line) return cartFetch('cart/change.json', { id: key, quantity: line.quantity - 1 });
      return null;
    });
  }

  // The drawer guard: a drawer that opens within 1.5 s of one of our own cart calls, with no shopper click on a
  // cart opener in between, is Kaching reacting to our call and gets closed again.
  let guardUntil = 0;
  function guardDrawer() {
    guardUntil = Date.now() + 1500;
    if (drawerIsOpen() && ourCall && !shopperOpenedDrawer) window.kachingCartApi?.closeCart?.();
  }
  let shopperTimer = 0;
  function markShopperOpen() {
    shopperOpenedDrawer = true;
    ourCall = false;
    clearTimeout(shopperTimer);
    // if the drawer never opens, do not leave the guard switched off for the rest of the visit
    shopperTimer = setTimeout(() => { if (!drawerIsOpen()) shopperOpenedDrawer = false; }, 3000);
  }

  async function checkout(btn) {
    btn.disabled = true;
    btn.classList.add('is-checking-out');
    btn.textContent = 'Loading...';
    // every queued call is capped by its 10 s timeout; wait for them so checkout gets the bundle as shown
    await settle(queue, 25000);
    // a gift left in the cart under the gift amount (Kaching removes it after a moment) is taken out first
    const giftLine = cart.items.find(isGift);
    if (giftLine && nonGiftTotal() < giftCents) {
      try { await cartFetch('cart/change.json', { id: giftLine.key, quantity: 0 }); } catch (e) { /* Kaching removes it too */ }
    }
    await settle(window.kachingCartApi?.refreshCart?.(), 1500);
    window.location.href = `${base}checkout`;
  }

  function chooseGift() {
    const kc = window.kachingCartApi;
    if (!kc?.openCart) { window.location.href = root.dataset.cart; return; }
    markShopperOpen();
    kc.openCart();
    // the drawer opens its gift picker on unlock; open it by hand if it is not up yet
    setTimeout(() => {
      if (!document.querySelector('.kaching-cart-modal')) document.querySelector('.kaching-cart__tpb-modal-open-button')?.click();
    }, 600);
  }

  // Quick view, aug11's product popup
  const modal = $('[data-hb-modal]');
  let modalCard = null;
  let modalOpener = null;
  function updateModalFooter() {
    if (!modalCard || modal.getAttribute('aria-hidden') !== 'false') return;
    const qty = qtyOf(Number(modalCard.dataset.variant));
    const max = maxOf(modalCard);
    $('[data-hb-modal-link]').classList.toggle('custom-bundle-hidden', qty > 0);
    $('[data-hb-modal-add]').classList.toggle('custom-bundle-hidden', qty > 0);
    $('[data-hb-modal-qty]').classList.toggle('custom-bundle-hidden', qty === 0);
    $('[data-hb-modal-add]').disabled = max < 1;
    $('[data-hb-modal-qty-value]').textContent = String(qty || 1);
    $('[data-hb-modal-plus]').disabled = qty >= max;
    if (qty > 0 && document.activeElement === $('[data-hb-modal-add]')) $(qty >= max ? '[data-hb-modal-minus]' : '[data-hb-modal-plus]').focus();
  }
  // aug11 shows the hat's review stars under the quick view title (Loox there, Judge.me here)
  // Loox's own star shapes (aug11's quick view): solid, outline, and a half that is solid on the left
  const starFill = 'M24 9.425c0 .212-.125.443-.375.693l-5.236 5.105 1.24 7.212c.01.067.015.164.015.289a.85.85 0 0 1-.151.511.51.51 0 0 1-.44.21c-.183 0-.375-.058-.577-.174L12 19.869l-6.476 3.404c-.212.115-.404.173-.577.173-.202 0-.353-.07-.454-.21a.85.85 0 0 1-.152-.511c0-.058.01-.154.03-.289l1.24-7.211-5.25-5.106C.12 9.858 0 9.628 0 9.425c0-.355.27-.577.808-.663l7.24-1.053 3.245-6.562c.183-.395.418-.592.707-.592s.524.197.707.592l3.245 6.562 7.24 1.053c.539.086.808.308.808.663Z';
  const starLine = 'm16.399 14.574 4.413-4.283-6.086-.894L12 3.887l-2.726 5.51-6.086.894L7.6 14.574l-1.053 6.072L12 17.776l5.438 2.87-1.039-6.072ZM24 9.425c0 .212-.125.443-.375.693l-5.236 5.105 1.24 7.212c.01.067.015.164.015.289 0 .48-.197.72-.591.72-.183 0-.375-.057-.577-.172L12 19.867l-6.476 3.404c-.212.115-.404.173-.577.173-.202 0-.353-.07-.454-.21a.85.85 0 0 1-.152-.511c0-.058.01-.154.03-.289l1.24-7.211-5.25-5.106C.12 9.858 0 9.628 0 9.425c0-.355.27-.577.808-.663l7.24-1.053 3.245-6.562c.183-.395.418-.592.707-.592s.524.197.707.592l3.245 6.562 7.24 1.053c.539.086.808.308.808.663Z';
  const star = (fill) => `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">${
    fill === 'full' ? `<path d="${starFill}"/>`
    : fill === 'empty' ? `<path d="${starLine}"/>`
    : `<path d="${starLine}" style="clip-path: inset(0 0 0 50%)"/><path d="${starFill}" style="clip-path: inset(0 50% 0 0)"/>`}</svg>`;
  function renderReviews(card) {
    const box = $('[data-hb-modal-reviews]');
    const rating = Math.round((Number(card.dataset.rating) || 0) * 2) / 2;
    // a count with no rating would read as zero stars: show nothing instead
    const raters = rating > 0 ? Number(card.dataset.raters) || 0 : 0;
    // like aug11, a hat with no reviews keeps the empty row (and its 8px gap) under the title
    if (!raters) { box.innerHTML = ''; return; }
    const stars = [1, 2, 3, 4, 5].map((i) => star(rating >= i ? 'full' : rating >= i - 0.5 ? 'half' : 'empty')).join('');
    box.innerHTML = `<a class="custom-bundle-modal__reviews-link" href="${card.dataset.url}#judgeme_product_reviews" aria-label="Rated ${card.dataset.rating} out of 5, ${raters} reviews">`
      + `<span class="custom-bundle-modal__stars">${stars}</span><span class="custom-bundle-modal__reviews-count">&nbsp;(${raters})</span></a>`;
  }

  function openModal(card, opener) {
    modalCard = card;
    modalOpener = opener;
    const images = (card.dataset.images || card.dataset.img).split('|').filter(Boolean);
    const track = $('[data-hb-modal-track]');
    const thumbs = $('[data-hb-modal-thumbs]');
    track.innerHTML = '';
    thumbs.innerHTML = '';
    images.forEach((src, i) => {
      const slide = document.createElement('div');
      slide.className = 'custom-bundle-modal__gallery-slide';
      const img = document.createElement('img');
      img.src = src; img.alt = card.dataset.title; img.loading = 'lazy';
      slide.append(img);
      track.append(slide);
      const thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = `custom-bundle-modal__thumb${i === 0 ? ' is-active' : ''}`;
      thumb.setAttribute('aria-label', `View image ${i + 1}`);
      thumb.innerHTML = `<img src="${src}" alt="" loading="lazy">`;
      thumb.addEventListener('click', () => {
        slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        thumbs.querySelectorAll('.custom-bundle-modal__thumb').forEach((t) => t.classList.toggle('is-active', t === thumb));
      });
      thumbs.append(thumb);
    });
    const title = $('[data-hb-modal-title]');
    title.textContent = card.dataset.title;
    title.href = card.dataset.url;
    $('[data-hb-modal-link]').href = card.dataset.url;
    renderReviews(card);
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('custom-bundle-modal-open');
    updateModalFooter();
    modal.querySelector('.custom-bundle-modal__close').focus();
  }
  function closeModal() {
    if (modal.getAttribute('aria-hidden') !== 'false') return;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('custom-bundle-modal-open');
    modalOpener?.focus?.();
    modalCard = null;
  }
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeModal();
    // keep Tab inside the open popup
    if (e.key === 'Tab' && modal.getAttribute('aria-hidden') === 'false') {
      const f = [...modal.querySelectorAll('button, a[href]')].filter((el) => !el.disabled && el.offsetParent !== null);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  root.addEventListener('click', (e) => {
    const t = e.target;
    const card = t.closest('.custom-bundle__collection-product');
    if (card && t.closest('[data-hb-qv-open]')) { e.preventDefault(); openModal(card, t.closest('[data-hb-qv-open]')); }
    else if (card && t.closest('[data-hb-plus]')) change(Number(card.dataset.variant), 1, t.closest('[data-hb-plus]'));
    else if (card && t.closest('[data-hb-minus]')) change(Number(card.dataset.variant), -1);
    else if (t.closest('[data-hb-submit]')) checkout(t.closest('[data-hb-submit]'));
    else if (t.closest('[data-hb-gift]')) chooseGift();
    else if (t.closest('[data-hb-view]')) { panel.classList.remove('collapsed'); $('.custom-bundle__wrapper-left-title').focus(); }
    else if (t.closest('[data-hb-collapse]')) { panel.classList.add('collapsed'); $('[data-hb-view]').focus(); }
    else if (t.closest('[data-hb-prev]') || t.closest('[data-hb-next]')) {
      const track = $('[data-hb-slots]');
      const step = track.querySelector('.selected-product-box')?.offsetWidth || 100;
      track.scrollBy({ left: t.closest('[data-hb-next]') ? step : -step, behavior: 'smooth' });
    }
    else if (t.closest('[data-hb-modal-close]')) closeModal();
    else if (t.closest('[data-hb-modal-add]') || t.closest('[data-hb-modal-plus]')) { if (modalCard) change(Number(modalCard.dataset.variant), 1); }
    else if (t.closest('[data-hb-modal-minus]')) { if (modalCard) change(Number(modalCard.dataset.variant), -1); }
  });
  $('[data-hb-slots]').addEventListener('scroll', updateArrows, { passive: true });

  // Picks made in the Kaching drawer (quantity, remove, gift) show up here when it closes
  let drawerOpen = false;
  new MutationObserver(() => {
    const open = drawerIsOpen();
    if (open && !drawerOpen && ourCall && !shopperOpenedDrawer && Date.now() < guardUntil) window.kachingCartApi?.closeCart?.();
    if (drawerOpen && !open) { shopperOpenedDrawer = false; run(async () => {}); }
    drawerOpen = open;
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  // any click outside the bundle (header bag, a Kaching button, anything else) counts as the shopper, not us
  document.addEventListener('click', (e) => { if (!root.contains(e.target)) markShopperOpen(); }, true);
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    // back from checkout: the page comes back as it was left, with Checkout still on Loading...
    $('[data-hb-submit]').classList.remove('is-checking-out');
    run(async () => {});
  });

  // aug11's Bestseller badge: the first 3 hats in stock in the collection's best-selling sort, which Shopify ranks by real
  // sales. The section answers with just their ids when it is asked for itself on that collection page.
  // A New badge from a cached page goes once the hat is past 30 days
  $$('.custom-bundle__collection-product').forEach((card) => {
    const badge = card.querySelector('.custom-bundle__collection-product-media--badge');
    if (badge && Date.now() / 1000 - Number(card.dataset.created) > 2592000) badge.remove();
  });
  if (root.dataset.best) {
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    fetch(`${root.dataset.best}?sort_by=best-selling&section_id=hat-bundle${preview ? `&preview_theme_id=${preview}` : ''}`)
      .then((r) => (r.ok ? r.text() : ''))
      .then((html) => {
        const el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-hb-best]');
        // the free gift hats sell at $0 through Kaching, so their units are not bestseller proof
        const skip = (root.dataset.bestExclude || '').split(',');
        const grid = new Set([...cards.values()].map((c) => c.dataset.pid));
        const ids = (el?.dataset.hbBest || '').split(',').filter((id) => id && !skip.includes(id) && grid.has(id)).slice(0, 3);
        $$('.custom-bundle__collection-product').forEach((card) => {
          if (!ids.includes(card.dataset.pid)) return;
          const media = card.querySelector('.custom-bundle__collection-product-media');
          let badge = media.querySelector('.custom-bundle__collection-product-media--badge');
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'custom-bundle__collection-product-media--badge';
            media.prepend(badge);
          }
          // Bestseller wins over New, as on aug11
          badge.textContent = root.dataset.bestLabel || 'Bestseller';
        });
      })
      .catch(() => {});
  }

  render();
  run(async () => {});
})();
